import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Row, Col } from "reactstrap";
import PropTypes from "prop-types";
import { FormattedDate } from "react-intl";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";

import style from "../Alert/Alert.module.scss";
import Side from "../Order/Field/Side";
import { Field } from "../Order/Field/Field";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";

const ModalInstruction = ({ open, toggle, alert, user, ...props }) => {
  const [closing, setClosing] = useState(false);
  const [decimalAmount, setDecimalAmount] = useState(false);
  const instruction = JSON.parse(alert.refTag);

  const handleClose = () => {
    const eventIN = { ...alert };
    eventIN.status = "Closed";
    setClosing(true);
    props.fetchs.updateAlert({ eventIN }, () => {
      setClosing(false);
      toggle();
    });
  };

  useEffect(() => {
    if (instruction) {
      fetchGetAssetInformation({ assetId: instruction.price })
        .then((response) => {
          setDecimalAmount(response.info.SubAssetClassDecimalPlaces);
        })
        .catch((err) => {
          console.error(err);
          showToast("Error fetching the Asset Class Information", true);
        });
    }
  }, []);

  return (
    <Modal isOpen={open} className={style.modal}>
      <ModalHeader toggle={toggle} className={style.header} style={{ padding: "10px 15px" }}>
        <div>{alert.trigger.trim()}</div>
        <div>
          <i className="fa fa-exclamation-triangle mr-2" aria-hidden="true" />
          <FormattedDate value={alert.date} />
        </div>
      </ModalHeader>
      <ModalBody className={style.body} style={{ textAlign: "center" }}>
        <Row>
          <Col style={{ margin: "auto auto 5px auto" }}>
            <Side readonly side={instruction.side} />
          </Col>
          <Col>
            <Field label="Quantity">
              <NumberFormatInput
                type="text"
                customInput={Input}
                value={instruction.quantity}
                dataTypeDecimalName="quantity"
              />
            </Field>
          </Col>
        </Row>
        <Row>
          <Col>
            <Field label="Price">
              <NumberFormatInput
                type="text"
                customInput={Input}
                decimalScale={decimalAmount}
                value={instruction.price}
                dataTypeDecimalName="price"
              />
            </Field>
          </Col>
          <Col>
            <Field label="Asset">
              <Input value={instruction.asset} />
            </Field>
          </Col>
        </Row>
        <Row>
          <Col>
            <Field label="Note">
              <Input type="textarea" value={instruction.note} />
            </Field>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        {user && user.role === "Advisor" && alert.status === "WorkingAdvisor" && (
          <LaddaButton
            className="btn btn-ladda btn-primary"
            loading={closing}
            disabled={closing}
            onClick={handleClose}
            data-style={EXPAND_RIGHT}
          >
            {closing ? "Closing..." : "Close"}
          </LaddaButton>
        )}
      </ModalFooter>
    </Modal>
  );
};

ModalInstruction.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  fetchs: PropTypes.object.isRequired,
  alert: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default ModalInstruction;
